import React, { useState , useEffect, useRef,useReducer} from "react"
import './style.css'
import monster from "../img/monsterclick (1).png"
import coinimg from "../img/pngwing.com.png"
import {getFirestore,doc, getDoc, updateDoc, collection, query, getDocs,} from "firebase/firestore"
import { getAuth, onAuthStateChanged } from "firebase/auth";

export const Clicker = () =>{
const [count, setCount] = useState(),
    [money, setMoney] = useState(0),
    [level, setLevel] = useState(),
    [levelPrice, setLevelPrice] = useState(1000);
const [maleArray, setMaleArr] = useState([]);
const db = getFirestore();
const auth = getAuth();

let checkTest = true;

onAuthStateChanged(auth, (user) => {
    if (user) {
        const uid = user.uid;
        const ref = doc(db, "userinfo", uid);
        getDoc(ref)
            .then(docSnap => {
                if (docSnap.exists()) {
                    setCount(docSnap.data().count);
                    setMoney(docSnap.data().money);
                    setLevel(docSnap.data().level);
                } else {
                    console.log("No such document!");
                }
            })
            .then(updateDoc(ref, {
                money: money,
                count: count,
                level: level,
                levelPrice: levelPrice
            }))
            .catch()
        } else {}
});

function onClickPlus() {
    setMoney(money + level);
}

function onCLickLevelUp() {
    if (money > levelPrice) {
        setMoney(money - levelPrice);
        setLevel(level + 1);
        setLevelPrice(levelPrice * 2);
    }
}

let nameScore = '',
    moneyScore,
    scoreObject,
    socreArrLoc = [],
    moneyArr = [1];

const CollectionRef = collection(db, "userinfo");
const Update = async () => {
    try {

        const data = await getDocs(CollectionRef);
        data
            .docs
            .map((doc) => (
                nameScore = doc.data().name.name,
                moneyScore = doc.data().money,
                scoreObject = {
                    name: doc
                        .data()
                        .name
                        .name,
                    money: doc
                        .data()
                        .money
                },
                socreArrLoc.push(scoreObject)

            ));

    } catch (err) {}
}
Update();

function stat() {
    setMaleArr([...socreArrLoc]);
}
    return(
       <form action="">
    <div className="clicker__container">
        <div className="clicker_money">
            <img src={coinimg} alt=""/>
            <h1 className="ttt">
                {money}</h1>
        </div>
        <div className="level__count">
            <h1>
                Lvl.{level}</h1>
        </div>
        <div className="clicker__cirle">
            <img onClick={onClickPlus} src={monster} draggable="false" alt=""/>
        </div>
        <div className="clicker__upgrade">
            <div className="but__upgrade">
                <div onClick={onCLickLevelUp}>Улучшение
                    <div className="div">{levelPrice}м</div>
                </div>
            </div>
            <div className="clicker__level" onClick={stat}>
                <div >
                    <div className="div"></div>Статистика игроков</div>
            </div>
        </div>
        <div className="clicker__stats">
            { maleArray.map(function(item,i){
           return  <div className="stats" key={i}>{item.name}: {item.money} очков</div>
            } ) }
        </div>
    </div>
</form>
    )
   
}